import { useEffect, useState, useContext } from 'react';
import {requestInstance} from '../../../services/AuthService/AccessTokenUpdateService'
import { BASE_URL } from '../../../api/constants';
import star from './images/star.png'
import { EmptyPage } from '../../../components/EmptyPage/EmptyPage'
import {SearchContext} from '../../../context/SearchContext'
import { Pagination } from '../../../components/Pagination/Pagination'
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../../context/UserContext';
  
const LoadingIndicator = () => <div className="WareHousesFeed__loading">Loading products...</div>

export const ProductsFeed = ({ selectedType, selectedFilters, showAll }) => {
  const [products, setProducts] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0)
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true); 
  const [selectedProductId, setSelectedProductId] = useState(null);
  const itemsPerPage = 16;
  const { searchQuery } = useContext(SearchContext);
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    const getProductsFeed = async (offset = 0) => {
      try {
        setLoading(true); 
        let url = `${BASE_URL}products/?limit=${itemsPerPage}&offset=${offset}`;

        // Only apply filters if not in "show all" mode
        if (!showAll) {
          const params = new URLSearchParams();
          
          if (searchQuery) {
            params.append('name', searchQuery)
          }

          if (selectedType) {
            params.append('category', selectedType);
          }

          if (selectedFilters.countries?.length > 0) {
            params.append('countries', selectedFilters.countries.join(','));
          }

          if (selectedFilters.ratings?.length > 0) {
            params.append('ratings', selectedFilters.ratings.join(','));
          }

          if (selectedFilters.types?.length > 0) {
            params.append('types', selectedFilters.types.join(','));
          }

          if (selectedFilters.searchQuery) {
            params.append('name', selectedFilters.searchQuery);
          }

          // Only append params if we have some
          if (params.toString()) {
            url += `&${params.toString()}`;
          }
        }
    
        console.log('Request URL:', url);

        const response = await requestInstance.get(url);
        console.log('Products API response:', response.data);
        setProducts(response.data.results || []);
        setNextPage(response.data.next);
        setPrevPage(response.data.previous);
        setTotalPages(Math.ceil((response.data.count || 0) / itemsPerPage));
        setCount(response.data.count || 0)
      } catch (error) {
        console.error('Failed to fetch products:', error);
        console.error('Error details:', error.response ? error.response.data : 'No response data');
        // Set empty data to handle gracefully
        setProducts([]);
        setNextPage(null);
        setPrevPage(null);
        setTotalPages(0);
        setCount(0);
      } finally {
        setLoading(false); 
      }
    };
    getProductsFeed();
  }, [itemsPerPage, selectedType, selectedFilters, searchQuery, showAll]);

  const handleProductClick = (e, productId) => {
    // Prevent default navigation
    e.preventDefault();
    
    // If user is not logged in, show login modal
    if (!user) {
      e.stopPropagation();
      setSelectedProductId(productId);
      // Store product ID for redirect after login
      localStorage.setItem('redirectProductId', productId);
      // Redirect to login page
      navigate('/login', { state: { from: 'products', redirectProductId: productId } });
      return;
    }
    
    // If user is logged in, navigate to product page
    navigate(`/product/${productId}`);
  };

  const mainPhoto = (item) => item.images.find(img => img.main)?.image;

  return (
    <div className='WareHousesFeed'>
      <div className='WareHousesFeed__container'>
        {loading ? (
          <LoadingIndicator /> 
        ) : products.length > 0 ? (
          <>
            <div className='WareHousesFeed__wrapper'>
              <div className='WareHousesFeed__slider'>
                {products.map((product) => (
                  <div key={product.id} className='ProductCard'>
                    {/* Use onClick handler instead of direct Link for unregistered users */}
                    <div onClick={(e) => handleProductClick(e, product.id)} style={{ cursor: 'pointer' }}>
                      <img className='WareHousesCatalog__product_img' src={mainPhoto(product)} alt={product.name} />
                      <div className='WareHousesCatalog__rating'><img src={star} alt='src' /> {product.rating}</div>
                      <p className='WareHousesCatalog__text'>{product.name}</p>
                      
                      {/* Show specific details only to logged in users */}
                      {user && <p className='WareHousesCatalog__text'>{product.makers} /{product.alcohol_percentage}%/ {product.production_year}</p>}
                      
                      <p className='WareHousesCatalog__price'>
                        {user ? 
                          `${product.currency} ${parseFloat(product.price).toFixed(2)}` :
                          "Register to see your price"
                        }
                      </p>
                      <button 
                        onClick={(e) => {
                          e.stopPropagation();
                          handleProductClick(e, product.id);
                        }}
                      >
                        {user ? "Buy" : "Register to Buy"}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              {totalPages > 1 && (
                <Pagination
                  itemsPerPage={itemsPerPage}
                  setObjects={setProducts}
                  setNextPage={setNextPage}
                  setPrevPage={setPrevPage}
                  nextPage={nextPage}
                  prevPage={prevPage}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  setCurrentPage={setCurrentPage}
                  count={count}
                />
              )}
            </div>
          </>
        ) : (
          <EmptyPage text={showAll ? "No products available." : "No products available for your search!"} />
        )}
      </div>
    </div>
  );
};

export default ProductsFeed;